import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ShopifyBilling',
  setup(__props) {

const customilyHelpLink =
    'https://help.customily.com/hc/en-us/articles/15994176886043-How-to-pause-or-cancel-your-Customily-account';
const adminShopifyLink = 'https://admin.shopify.com/';

return { __sfc: true,customilyHelpLink, adminShopifyLink }
}

})